import request from '../../axios';

const PatchEmployeeRequirement = async (
  payload: IEmployeeRequirementPayload,
  guid?: string,
) => {
  const newPayload = {
    title: payload.title,
    input_group: payload.input_group?.guid,
    input: payload.input?.guid,
    brs_type: payload.srs_type?.type,
    sub_input: payload.sub_input?.guid,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    wanted_number: payload.wanted_number || null,
    employing_duration: payload.employing_duration || null,
    employing_duration_unit: payload.employing_duration_unit?.value || null,
    only_massage_buyer: payload.only_massage_buyer || false,
    is_change_title: payload?.is_change_title || false,
    filter: 'requirement',
  };
  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...newPayload,
  });

  return response.data;
};

export default PatchEmployeeRequirement;
